import { PropTypes } from 'react';

const TableBody = ({ children }) => (
    <tbody>{children}</tbody>
);

TableBody.propTypes = {
    children: PropTypes.node.isRequired
};

export default TableBody;



// WEBPACK FOOTER //
// ./app/components/table/body.jsx